import { Link } from "react-router-dom";
import "./index.scss";
import React from "react";
import { isNullOrUndefined } from "../../common/utils";

export const LinkSpan = ({ to, keyId, text, className, target, active, matomoFn, ...restProps }) => {
  const _onClick = (e) => {
    if (active === false) {
      e.preventDefault();
    }
    if (!isNullOrUndefined(matomoFn)) {
      matomoFn();
    }
  };
  return (
    <Link
      to={to}
      key={keyId}
      target={target}
      className={active === false ? "disabledCursor" : ""}
      onClick={(e) => _onClick(e)}
      {...restProps}
    >
      <span className={"linkSpan " + (className ?? "")}>{text}</span>
    </Link>
  );
};
